export default __webpack_public_path__ + "static/media/2.5ad61e63.jpg";